/**
 * @typedef {string} FeatureFlag
 **/

/**
 * @enum {FeatureFlag}
 */
export const FEATURE_FLAGS = {
  GDPR_CONSENT: 'gdprConsent'
};
